import { save } from '../../apis/expensePayment';
import { expensePaymentSource } from '../../apis/parameter';
import { setExpensePaymentSource } from '../../main/duck/actions';
import { showMessage } from '../../modal/duck/actions';

export const saveAll = (payload) => async dispatch => {

    const res = await save(payload);

    if (res && res.isSuccess) {
        const sources = await expensePaymentSource();
        if (sources && sources.isSuccess && sources.data) {
            dispatch(setExpensePaymentSource(sources.data));
        }
    }

    const message = (res && res.data && res.data.message) ? res.data.message : 'SaveSucessful';

    dispatch(showMessage(message));
}